import React from 'react';
import { connect } from 'react-redux';

import ApiKeyCard from './ApiKeyCard';

import { generateApiKey } from '../../../../redux/auth/user/actions';
import { selectApiKey } from '../../../../redux/auth/user/selectors';
import { pushNotification } from '../../../../redux/ui/actions';

const ApiKeyCardConnected = (props) => <ApiKeyCard {...props} />;

const mapActionsToProps = {
  generateApiKey,
  pushNotification,
};

const mapStateToProps = (state) => ({
  apiKey: selectApiKey(state),
});

export default connect(mapStateToProps, mapActionsToProps)(ApiKeyCardConnected);
